import './style.scss'
import { useCallback, useContext, useEffect, useState } from 'react';
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, GridContainer, ScreenContainer } from 'src/style';
import { BorrowTermsAndConditions, LoanDetails, NewLoan, NewOverdraft, ReviewingLoanEligibility, Table } from 'src/component'
import { loanColumns } from 'src/utils/tableLayout';
import { MdAdd } from 'react-icons/md';
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const BorrowD1: React.FC = () => {
    const {API} = useContext(ApiContext)
    const [navPosition, setNavPosition] = useState(0)
    const [rowData, setRowData] = useState<any>(null)
    const [loans,  setLoans] = useState<any[]>([])
    const [view, setView] = useState<View>('')
    const {info:institutionData} = useContext(AppInfoContext)

   const handleGetLoans = useCallback(async()=>{
        const loans = await API.getLoans()
        if(loans)setLoans(loans)
    },[API])
    
    useEffect(()=>{
        handleGetLoans()
    },[])

    async function handleTableRow (data: any) {
        const loanDetails = await API.getLoanDetails({LoanAccountNumber: data.number})
        if(!!loanDetails){
            setRowData(loanDetails)
            setView('loan-details')
        }
    }


    return (
        <>
            <ScreenContainer padding='2.5' topPadding='0'>
                <CustomContainer
                    customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Borrow</AppSpan>
                    </CustomContainer>
                    <GridContainer 
                        height="3.6" topMargin="2" width='16.7'
                    >
                        <AbsoluteContainer 
                            width={navPosition === 0 ? '9.1' : '6.6'} 
                            top="0" left={`${navPosition}`}
                        >
                            <CustomContainer bgColor="#E7F6F5" height="3.6" radius="0.6" />
                        </AbsoluteContainer>
                        <FlexRow zIndex="2">
                            {/*<GridContainer */}
                            {/*    width='9.1' rightMargin='1' radius="0.6" hoverBgColor='#E7F6F5'*/}
                            {/*    onClick={() => setNavPosition(10.1)}*/}
                            {/*    className='borrrow-toggle-item'*/}
                            {/*>*/}
                            {/*    <AppSpan */}
                            {/*        fontWeight='600' cursor="pointer"*/}
                            {/*        color={navPosition === 10.1 ? "#0A756F" : "#667085"}*/}
                            {/*    >*/}
                            {/*        Overdraft*/}
                            {/*    </AppSpan>*/}
                            {/*</GridContainer>*/}
                            <GridContainer 
                                width='9.1' radius="0.6" hoverBgColor='#E7F6F5'
                                onClick={() => setNavPosition(0)}
                                className='borrrow-toggle-item'
                            >
                                <AppSpan 
                                    fontWeight='600' cursor="pointer"
                                    color={navPosition === 0 ? "#0A756F" : "#667085"}
                                >
                                    Loans
                                </AppSpan>
                            </GridContainer>
                        </FlexRow>
                    </GridContainer>
                    <CustomContainer
                        borderColor='#EAECF0' radius='0.8' topMargin='3'
                        shadow='0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
                    >
                        <FlexColumn minHeight='8' padding='2' alignItems='flex-start'>
                            <FlexRow justifyContent='space-between' gap='2' wrap='wrap'>
                                <AppText textSize='1.8' fontWeight='600' color='#101828'>{navPosition === 0 ? 'Active Loans' : 'View Eligibility'}</AppText>
                                <Button
                                    width={navPosition === 0 ? '14.9' : '17.7'} height='4' borderColor='#0D968F'
                                    hoverColor='#0D968F' hoverBgColor='#fff' titleSize='1.4'
                                    onClick={() => setView(navPosition === 0 ? 'new-loan':'terms_conditions')}
                                >
                                    <MdAdd style={{marginRight: '1rem', fontSize: '2rem'}} />
                                    {navPosition === 0 ? 'Apply for Loan' : 'New Request'}
                                </Button>
                            </FlexRow>
                        </FlexColumn>
                        { navPosition != 0 ?
                            <Table
                                tableColumns={loanColumns(handleTableRow,institutionData?.defaultCurrency)}
                                tableData={loans}
                                noDataText='No Active Loans'
                                noRadius
                                customStyle
                            />
                            :
                            <GridContainer
                                bgColor='#E7F6F5' minHeight='8.2' padding='2' borderColor='E7F6F5'
                                topPadding='1' bottomPadding='1'
                            >
                                {/* <FlexRow gap='2' wrap='wrap'>
                                    <CustomContainer width='18.1'>
                                        <AppSpan>Min Overdraft Limit</AppSpan>
                                        <AppText fontWeight='700' color='#0D968F'>N500,000</AppText>
                                    </CustomContainer>
                                    <CustomContainer width='18.1'>
                                        <AppSpan>Max Overdraft Limit</AppSpan>
                                        <AppText fontWeight='700' color='#0D968F'>N2,000,000</AppText>
                                    </CustomContainer>
                                    <CustomContainer width='18.1'>
                                        <AppSpan>Interest Rate</AppSpan>
                                        <AppText fontWeight='700' color='#0D968F'>12%</AppText>
                                    </CustomContainer>
                                    <CustomContainer width='18.1'>
                                        <AppSpan>Overdraft Fee</AppSpan>
                                        <AppText fontWeight='700' color='#0D968F'>5%</AppText>
                                    </CustomContainer>
                                </FlexRow> */}
                            </GridContainer>
                        }
                    </CustomContainer>
                    {/* <ComingSoon /> */}
                </CustomContainer>
            </ScreenContainer>
            { view === 'terms_conditions' &&
                <BorrowTermsAndConditions
                    close={() => setView('')}
                    handleNext={() => setView('new-overdraft')}
                />
            }
            { view === 'reviewing_eligibility' &&
                <ReviewingLoanEligibility
                    close={() => setView('')}
                    handleNext={() => setView('new-loan')}
                />
            }
            { view === 'new-overdraft' &&
                <NewOverdraft
                    close={() => setView('')}
                />
            }
            { view === 'new-loan' &&
                <NewLoan
                    close={() => setView('')}
                    view={view}
                    setView={setView}
                />
            }
            { view === 'loan-details' &&
                <LoanDetails
                    close={() => setView('')}
                    data={rowData}
                />
            }
        </>
    );
}
type View = 'new-overdraft' | 'new-loan' | 'loan-details' | 'terms_conditions' | 'reviewing_eligibility' | ''
